import { gql } from '@apollo/client';

export const UPLOAD_COMPANY_LOGO = gql`
    mutation UploadCompanyLogo($id: ID!, $file: Upload!) {
        uploadCompanyLogo(id: $id, file: $file) {
            id
        }
    }
`;
